const SectionWrapper = ({ children, className = '' }) => (
  <section className={`w-full py-12 px-4 md:px-12 lg:px-20 ${className}`}>
    {children}
  </section>
);

export default SectionWrapper;
